module.exports = __webpack_public_path__ + "static/media/sp11.920b9f87.JPG";